export type DeliveryRegion = {
  id: string;
  name: string;
  chargeGbp: number | null;
  notes: string;
};

export type SiteConfig = {
  brandName: string;
  domain: string;
  locale: string;
  currencyCode: "GBP";
  ordersEnabled: boolean;
  deliveryNotice: string;
  /**
   * Set true only after fulfilment tests show we can meet deliveryNotice.
   * The notice stays hidden from customers until this is true and products exist.
   */
  deliveryEstimateVerified: boolean;
  /**
   * Fill after the UK company is registered.
   * Each field is shown on the site only when it has a value.
   */
  company: {
    registeredName: string;
    companyNumber: string;
    registeredAddress: string;
  };
  contact: {
    email: string;
    phone: string;
    hours: string;
  };
  delivery: {
    regions: DeliveryRegion[];
  };
  policies: {
    deliveryAndReturns: string;
    privacy: string;
    terms: string;
  };
  seo: {
    defaultDescription: string;
  };
};

/**
 * Public settings. Leave empty strings and empty arrays until the real
 * details are confirmed. Do not invent company, contact, charge or policy values.
 */
export const site: SiteConfig = {
  brandName: "Beautiful Jewellery",
  domain: "https://beautiful-jewellery.com",
  locale: "en-GB",
  currencyCode: "GBP",
  ordersEnabled: false,
  deliveryNotice:
    "Estimated delivery: 5–7 business days after order confirmation. We’ll let you know if your order is delayed.",
  deliveryEstimateVerified: false,
  company: {
    registeredName: "",
    companyNumber: "",
    registeredAddress: ""
  },
  contact: {
    email: "",
    phone: "",
    hours: ""
  },
  delivery: {
    regions: []
  },
  policies: {
    deliveryAndReturns: "",
    privacy: "",
    terms: ""
  },
  seo: {
    defaultDescription:
      "Jewellery for everyday moments. A collection of rings, necklaces, earrings and bracelets is on its way."
  }
};

export function hasText(value: string): boolean {
  return value.trim().length > 0;
}

export function companyLines(): string[] {
  return [
    site.company.registeredName,
    site.company.companyNumber
      ? `Company number ${site.company.companyNumber}`
      : "",
    site.company.registeredAddress
  ].filter(hasText);
}

export function hasCompanyDetails(): boolean {
  return companyLines().length > 0;
}

export function hasContactDetails(): boolean {
  return (
    hasText(site.contact.email) ||
    hasText(site.contact.phone) ||
    hasText(site.contact.hours)
  );
}
